import jwtDecode from 'jwt-decode';
import { getToken, TOKEN } from '../utils/constants';
import { isEmpty } from './isEmpty';


export const getDefaultPath = () => {
  let userInfo = localStorage.getItem('userinfo');
  userInfo = JSON.parse(userInfo);
  let userRole = localStorage.getItem('userrole');
  userRole = JSON.parse(userRole);
  if (userInfo && userRole) {
    return "/Dashboard"
  }
  else if (!userInfo && !userRole) {
    // return '/login'
  }
}

export const isAuthTrueAndValid = () => {
  if (!isEmpty(sessionStorage.getItem(getToken()))) {
    const userInfo = jwtDecode(sessionStorage.getItem(getToken()))
    if (userInfo) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export const getUserInfo = () => {
  const tokenName = getToken()
  if (sessionStorage.getItem(tokenName)) {
    return jwtDecode(sessionStorage.getItem(TOKEN));
  } else return null
}

export const fetchUserInfo = () => {
  let userDetail;
  let userInfo = localStorage.getItem('userinfo');
  userInfo = JSON.parse(userInfo);
  let userRole = localStorage.getItem('userrole');
  userRole = JSON.parse(userRole);
  if (!userInfo && !userRole) {
    userDetail = '';
  } else {
    userDetail = { userInfo: userInfo, userRole: userRole };
  }
  return userDetail;
}